import { api } from '../api';
import { WITHDRAW_INIT } from '../../constants/cryptoWithdraw';
import {
  WITHDRAW_INIT_WHITELIST,
  WITHDRAW_WHITELIST_EXPRESS
} from '../../constants/withdrawalWhitelist';
import {
  WithdrawCryptoInitRequestType,
  WithdrawCryptoInitResponseType,
  WithdrawWhitelistRequestType
} from './types';

export const cryptoWithdrawSlice = api.injectEndpoints({
  endpoints: (build) => ({
    cryptoWithdrawInit: build.mutation<
      WithdrawCryptoInitResponseType,
      WithdrawCryptoInitRequestType
    >({
      query(data) {
        return {
          url: WITHDRAW_INIT,
          method: 'POST',
          body: data
        };
      }
      /*      transformResponse: (response: WithdrawCryptoInitResponseType) => {
              // Clean the response to remove non-serializable objects
              if (response && typeof response === 'object') {
                return JSON.parse(
                  JSON.stringify(response, (key, value) => {
                    // Remove Request, Response objects and other non-serializable items
                    if (
                      value instanceof Request ||
                      value instanceof Response ||
                      value instanceof Headers ||
                      typeof value === 'function' ||
                      key === 'request'
                    ) {
                      return undefined;
                    }
                    return value;
                  })
                );
              }
              return response;
            } */
    }),

    /**
     * Withdraw to a saved destination with the usual CW second factor. Used
     * whenever the token does not explicitly permit express, when the saved
     * preference is known to be false, or after an express refusal.
     */
    cryptoWithdrawWhitelist: build.mutation<
      WithdrawCryptoInitResponseType,
      WithdrawWhitelistRequestType
    >({
      query(data) {
        return {
          url: WITHDRAW_INIT_WHITELIST,
          method: 'POST',
          body: data
        };
      }
    }),

    /**
     * The same withdrawal without a second factor. This route carries no MFA
     * policy: financial-coordinator reads the live preference on every request
     * and refuses with 10073 when it is off, so never pre-fetch a challenge or
     * treat the JWT claim as permission.
     */
    cryptoWithdrawWhitelistExpress: build.mutation<
      WithdrawCryptoInitResponseType,
      WithdrawWhitelistRequestType
    >({
      query(data) {
        return {
          url: WITHDRAW_WHITELIST_EXPRESS,
          method: 'POST',
          body: data
        };
      }
    })
  }),

  overrideExisting: false
});

export const {
  useCryptoWithdrawInitMutation,
  useCryptoWithdrawWhitelistMutation,
  useCryptoWithdrawWhitelistExpressMutation
} = cryptoWithdrawSlice;
